import React from 'react'

const Capacitaciones = () => {
  return (
    <div>Capacitaciones</div>
  )
}

export default Capacitaciones